/**
 * App — root routing component.
 *
 * Admin routes (wrapped in AdminLayout, redirects to /login if unauthenticated):
 *   /                  Upload Draft
 *   /overview          Draft Overview (list, status, delete)
 *   /preview/review    Review & Thank-you page text editor / preview
 *   /preview/emails    Email template editor / preview
 *   /reviews           Etsy review approval (AI reply workflow)
 *
 * Public routes (no auth required):
 *   /review/:draftId   Customer-facing draft review form
 *   /thank-you         Post-submission confirmation page
 *   /login             Admin login
 */
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLayout from "./components/AdminLayout";
import AdminUploadPage from "./components/AdminUploadPage";
import DraftOverview from "./components/DraftOverview";
import DraftReviewForm from "./components/DraftReviewForm";
import DraftReviewPreview from "./components/DraftReviewPreview";
import EmailPreview from "./components/EmailPreview";
import ReviewsPage from "./components/ReviewsPage";
import OrdersPage from "./components/OrdersPage";
import OrderConfirmationsPage from "./components/OrderConfirmationsPage";
import TestOrdersPage from "./components/TestOrdersPage";
import OrderReviewPreview from "./components/OrderReviewPreview";
import OrderEmailPreview from "./components/OrderEmailPreview";
import ShippingEmailPreview from "./components/ShippingEmailPreview";
import DeliveryEmailPreview from "./components/DeliveryEmailPreview";
import ProgressEmailPreview from "./components/ProgressEmailPreview";
import DeliveryPage from "./components/DeliveryPage";
import ReviewAiSettings from "./components/ReviewAiSettings";
import OrderReviewForm from "./components/OrderReviewForm";
import OrderThankYouPage from "./components/OrderThankYouPage";
import ShippingPage from "./components/ShippingPage";
import SyncSettings from "./components/SyncSettings";
import InvoiceSettings from "./components/InvoiceSettings";
import DashboardPage from "./components/DashboardPage";
import ProduktionPage from "./components/ProduktionPage";
import ReportingPage from "./components/ReportingPage";
import DraftCandidatesPage from "./components/DraftCandidatesPage";
import LoginPage from "./components/LoginPage";
import ThankYouPage from "./components/ThankYouPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AdminLayout><AdminUploadPage /></AdminLayout>} />
        <Route path="/overview" element={<AdminLayout><DraftOverview /></AdminLayout>} />
        <Route path="/preview/review" element={<AdminLayout><DraftReviewPreview /></AdminLayout>} />
        <Route path="/preview/emails" element={<AdminLayout><EmailPreview /></AdminLayout>} />
        <Route path="/reviews" element={<AdminLayout><ReviewsPage /></AdminLayout>} />
        <Route path="/orders" element={<AdminLayout><OrdersPage /></AdminLayout>} />
        <Route path="/order-confirmations" element={<AdminLayout><OrderConfirmationsPage /></AdminLayout>} />
        <Route path="/preview/order-review" element={<AdminLayout><OrderReviewPreview /></AdminLayout>} />
        <Route path="/preview/order-emails" element={<AdminLayout><OrderEmailPreview /></AdminLayout>} />
        <Route path="/preview/shipping-emails" element={<AdminLayout><ShippingEmailPreview /></AdminLayout>} />
        <Route path="/preview/delivery-emails" element={<AdminLayout><DeliveryEmailPreview /></AdminLayout>} />
        <Route path="/preview/progress-emails" element={<AdminLayout><ProgressEmailPreview /></AdminLayout>} />
        <Route path="/delivery" element={<AdminLayout><DeliveryPage /></AdminLayout>} />
        <Route path="/review/:draftId" element={<DraftReviewForm />} />
        <Route path="/order-review/:orderId" element={<OrderReviewForm />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/order-thank-you" element={<OrderThankYouPage />} />
        <Route path="/test-orders" element={<AdminLayout><TestOrdersPage /></AdminLayout>} />
        <Route path="/shipping" element={<AdminLayout><ShippingPage /></AdminLayout>} />
        <Route path="/settings/sync" element={<AdminLayout><SyncSettings /></AdminLayout>} />
        <Route path="/settings/review-ai" element={<AdminLayout><ReviewAiSettings /></AdminLayout>} />
        <Route path="/settings/invoices" element={<AdminLayout><InvoiceSettings /></AdminLayout>} />
        <Route path="/dashboard" element={<AdminLayout><DashboardPage /></AdminLayout>} />
        <Route path="/produktion" element={<AdminLayout><ProduktionPage /></AdminLayout>} />
        <Route path="/reporting" element={<AdminLayout><ReportingPage /></AdminLayout>} />
        <Route path="/draft-review" element={<AdminLayout><DraftCandidatesPage /></AdminLayout>} />
        <Route path="*" element={
          <div style={{ maxWidth: 600, margin: "auto", textAlign: "center", padding: "2em" }}>
            <h2>404 - Page Not Found</h2>
            <p>The page you are looking for does not exist.</p>
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
